import axios from "axios";
// import apiEndpoint from "";

const apiClient = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
});

let apiUrl = null;

apiClient.interceptors.request.use(async (config) => {
  if (!apiUrl) {
    const response = await fetch("/json/apiEndpoint.json");

    if (!response.ok) {
      throw new Error("Failed to load API endpoint configuration");
    }

    const settings = await response.json();

    apiUrl = settings.API_URL;
  }

  config.baseURL = apiUrl;

  const token = localStorage.getItem("token");

  if (token && !config.skipAuth) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export default apiClient;
